import React from "react";
import VideoForm from "./VideoForm";
import Aboutsection from "./Aboutsection";
import { Helmet } from "react-helmet";
import useWebsiteSetting ,{useBannerdata,usePagemetaTags} from "../FetchAPI";

export default function About() {

    const [bannerdata] = useBannerdata();
    const [webSetting] = useWebsiteSetting();
  const [PagemetaTags] = usePagemetaTags();


  //Page Meta Tags

  return (
    <>
      <Helmet>
        <title>{PagemetaTags.AboutMetatitle}</title>
        <meta name="keywords" content={PagemetaTags.AboutMetaKeyword} />
        <meta name="description" content={PagemetaTags.AboutMetaDesc} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

 <div className="banner-wrap">
     <div  className="banner-bg"  style={{    backgroundImage: `url(${bannerdata.about_banner})`,  }} >
        <div className="banner-overlay"></div>
        <div className="banner-top-line"></div>
        <div className="banner-content">
          <h1>About Us</h1>
          <nav className="breadcrumb-bar" aria-label="breadcrumb">
            <a href="/">Home</a>
            <span className="sep">›</span>
            <span className="current">About Us</span>
          </nav>
        </div>
      </div>
      <div className="banner-bottom-line"></div>
    </div>


<Aboutsection/>


      <VideoForm
        IframeVideo={webSetting.iframe_video}
        SectionTitle={webSetting.video_form_title}
      />



      
    </>
  );
}
